// extracted by mini-css-extract-plugin
export default {"mainBlock":"Footer_mainBlock__XW+Xj","hoverText":"Footer_hoverText__NSNBB"};